import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.currentTab = 'ledger'

    this.styleElement = document.getElementById('dynamic-print-style')
    if (!this.styleElement) {
      this.styleElement = document.createElement('style')
      this.styleElement.id = 'dynamic-print-style'
      document.head.appendChild(this.styleElement)
    }

    this.updatePrintStyle()
    this.filterWorkers()

    const form = this.element.querySelector('form')
    if (form) {
      const submitInputs = ['ym', 'unit', 'from', 'to', 'machine', 'site', 'team', 'worker', 'paper']
      submitInputs.forEach(id => {
        const el = document.getElementById(id)
        if (el) {
          el.addEventListener('change', () => {
            setTimeout(() => {
              form.requestSubmit()
            }, 50)
          })
        }
      })
    }
  }

  disconnect() {
    if (this.styleElement) {
      this.styleElement.remove()
      this.styleElement = null
    }
  }

  setActiveTab(event) {
    const tab = event.currentTarget.dataset.type

    this.element.querySelectorAll('.tab').forEach(b =>
      b.classList.toggle('active', b.dataset.type === tab)
    )

    this.element.querySelectorAll('.report').forEach(r => r.classList.remove('active'))
    const target = document.getElementById(`report-${tab}`)
    if (target) target.classList.add('active')

    const reportType = document.getElementById('reportType')
    if (reportType) reportType.value = tab

    this.currentTab = tab
    this.updateCondText()
    this.updatePrintStyle()
  }

  switchReport(event) {
    const tab = event.currentTarget.value

    this.element.querySelectorAll('.tab').forEach(b =>
      b.classList.toggle('active', b.dataset.type === tab)
    )

    this.element.querySelectorAll('.report').forEach(r => r.classList.remove('active'))
    const target = document.getElementById(`report-${tab}`)
    if (target) target.classList.add('active')

    this.currentTab = tab
    this.updateCondText()
    this.updatePrintStyle()
  }

  updateCondText() {
    const condText = document.getElementById('condText')
    if (!condText) return

    const reportType = document.getElementById('reportType')
    const machine = document.getElementById('machine')
    const ym = document.getElementById('ym')

    if (reportType && machine && ym) {
      const [y, m] = ym.value.split('-').map(Number)
      const reportLabel = reportType.options[reportType.selectedIndex].text
      const machineLabel = machine.options[machine.selectedIndex].text
      condText.textContent = `${y}年${m}月分 ／ ${reportLabel} ／ ${machineLabel}`
    }
  }

  resetCond() {
    const reportType = document.getElementById('reportType')
    const ym = document.getElementById('ym')
    const from = document.getElementById('from')
    const to = document.getElementById('to')
    const machine = document.getElementById('machine')
    const site = document.getElementById('site')
    const team = document.getElementById('team')
    const worker = document.getElementById('worker')

    const today = new Date()
    const y = today.getFullYear()
    const m = String(today.getMonth() + 1).padStart(2, '0')
    const lastDay = new Date(y, today.getMonth() + 1, 0).getDate()

    if (reportType) reportType.value = 'ledger'
    if (ym)      ym.value = `${y}-${m}`
    if (from)    from.value = `${y}-${m}-01`
    if (to)      to.value = `${y}-${m}-${lastDay}`
    if (machine) machine.value = 'all'
    if (site)    site.value = 'all'
    if (team)    team.value = 'all'
    if (worker)  worker.value = 'all'

    this.element.querySelectorAll('.tab').forEach(b =>
      b.classList.toggle('active', b.dataset.type === 'ledger')
    )
    this.element.querySelectorAll('.report').forEach(r => r.classList.remove('active'))
    const target = document.getElementById('report-ledger')
    if (target) target.classList.add('active')

    this.currentTab = 'ledger'
    this.updateCondText()
    this.filterWorkers()

    const form = this.element.querySelector('form')
    if (form) {
      setTimeout(() => form.requestSubmit(), 50)
    }
  }

  handleYmChange(event) {
    const ymValue = event.currentTarget.value
    if (!ymValue) return

    const [year, month] = ymValue.split('-').map(Number)
    const fromInput = document.getElementById('from')
    const toInput = document.getElementById('to')

    const formattedMonth = String(month).padStart(2, '0')
    const lastDay = new Date(year, month, 0).getDate()

    if (fromInput) fromInput.value = `${year}-${formattedMonth}-01`
    if (toInput) toInput.value = `${year}-${formattedMonth}-${lastDay}`

    this.updateCondText()
  }

  submitPreview() {
    this.updateCondText()
  }

  printReport() {
    this.updatePrintStyle()
    window.print()
  }

  updatePrintStyle() {
    if (this.styleElement) {
      this.styleElement.innerHTML = `@media print { @page { size: A4 landscape; margin: 6mm 6mm 12mm 6mm; } }`
    }
  }

  filterWorkers() {
    const teamSelect = document.getElementById('team')
    const workerSelect = document.getElementById('worker')
    if (!teamSelect || !workerSelect) return

    const selectedTeamId = teamSelect.value
    const workerOptions = workerSelect.querySelectorAll('option')

    workerOptions.forEach(option => {
      if (option.value === 'all') {
        option.style.display = ''
        option.disabled = false
        option.hidden = false
        return
      }

      const teamId = option.dataset.teamId

      if (selectedTeamId === 'all') {
        option.style.display = ''
        option.disabled = false
        option.hidden = false
      } else if (teamId === selectedTeamId) {
        option.style.display = ''
        option.disabled = false
        option.hidden = false
      } else {
        option.style.display = 'none'
        option.disabled = true
        option.hidden = true
      }
    })

    const selectedOption = workerSelect.options[workerSelect.selectedIndex]
    if (selectedOption && selectedOption.disabled) {
      workerSelect.value = 'all'
    }
  }
}
